import React, { useCallback, useMemo, useState } from 'react';
import styles from './StorySchedule.module.scss';
import cx from 'classnames';
import SelectOption from 'engage/components/SelectOption/SelectOption';
import { millisecondsInHour, daysInWeek } from 'date-fns/constants';
import { HOURS, DAYS, WEEKS } from '../../constants';
import RadioButton from 'engage/components/RadioButton/RadioButton';
import { useTranslation } from 'react-i18next';
import { CustomButton } from 'engage/components/Button/Button';
import Icon from 'engage/components/Icon/Icon';
import { getMsValue, getRangeAndValue } from '../../utils';

const NotificationRangeSelection = ({ startTime, notification, onChange, onRemove, disabled }) => {

    const [value, setValue] = useState(getRangeAndValue(notification.offset).offset);
    const [range, setRange] = useState(getRangeAndValue(notification.offset).range);

    const { t } = useTranslation();

    const rangeOptions = useMemo(() => {
        const options = {
            [HOURS]: {
                title: 'general.hours',
                max: 24,
                disabled: true,
            },
            [DAYS]: {
                title: 'general.days',
                max: 30,
                disabled: true,
            },
            [WEEKS]: {
                title: 'storyboard.editor.schedule.notification.weeks',
                max: 53,
                disabled: true,
            }
        };
        if (startTime) {

            let offsetStart = startTime;
            let offsetEnd = Date.now();

            const hoursOffset = Math.trunc((offsetStart - offsetEnd) / millisecondsInHour);
            if (hoursOffset) {
                options[HOURS].disabled = false;
                options[HOURS].max = hoursOffset;
            }
            const daysOffset = Math.trunc(hoursOffset / 24);
            if (daysOffset) {
                options[DAYS].disabled = false;
                options[DAYS].max = daysOffset;
            }
            const weeksOffset = Math.trunc(daysOffset / daysInWeek);
            if (weeksOffset) {
                options[WEEKS].disabled = false;
                options[WEEKS].max = weeksOffset;
            }
        }
        return options;
    }, [startTime])

    const handleNotificationRangeChange = useCallback((newRange) => {
        setRange(newRange.id);
        if (value > newRange.max) {
            setValue(newRange.max);
        }
        onChange(notification.id, { offset: getMsValue(value, newRange.id) });
    }, [value]);

    const handleNumberChange = useCallback((e) => {
        const parsedValue = parseInt(e.target.value);
        setValue(parsedValue);
        onChange(notification.id, { offset: getMsValue(parsedValue, range) });
    }, [range]);

    const handleSendEmailChange = (e) => {
        onChange(notification.id, { sendEmail: e.currentTarget.checked });
    };

    return <div className={cx(styles.notification, {[styles.disabled]: disabled})}>
        <div className={styles.section}>
            <input
                type='number'
                value={value}
                min={1}
                max={rangeOptions[range]?.max}
                onChange={handleNumberChange}
                className={cx(styles.dataInput, styles.numberInput, { [styles.invalid]: !value || value < 0 || value > rangeOptions[range]?.max })}
                disabled={!startTime} />
            <SelectOption
                options={Object.entries(rangeOptions).map(([id, option]) => ({ id, ...option }))}
                onSelect={handleNotificationRangeChange}
                currentlySelected={rangeOptions[range]}
                currentInputClassName={styles.selectRanges}
            />
        </div>
        <div className={styles.section}>
            <RadioButton 
                className={styles.sendEmailCheckbox} 
                label={t('storyboard.editor.schedule.send_email')} 
                checked={notification?.sendEmail ?? false} 
                onChange={handleSendEmailChange} 
            />
            <CustomButton variant='link' className={styles.removeButton} onClick={() => onRemove(notification.id)}>
                <Icon src={'bin'} className={styles.binIcon} />
            </CustomButton>
        </div>
    </div >
}

export default NotificationRangeSelection;